import {parsePhoneNumberWithError} from "libphonenumber-js";
import {arrays, objects, sorting, strings, users} from "@atttomyx/shared-utils";
import {communication} from "@atttomyx/react-utils";
import {ANONYMOUS, LABEL_ANY, LABEL_NONE} from "../constants";
import {misc} from "@atttomyx/shared-constants";

export const sanitizeLabeledStrings = (labeledStrings) => {
    return labeledStrings ? labeledStrings.map(sanitizeLabeledString) : [];
};

export const sanitizeLabeledString = (labeledString) => {
    return {
        label: labeledString.label,
        value: labeledString.value,
    }
};

export const sanitizeLabeledDates = (labeledDates) => {
    return labeledDates ? labeledDates.map(sanitizeLabeledDate) : [];
};

export const sanitizeLabeledDate = (labeledDate) => {
    return {
        label: labeledDate.label,
        value: labeledDate.value,
    }
};

export const sanitizeLabeledAddresses = (labeledAddresses) => {
    return labeledAddresses ? labeledAddresses.map(sanitizeLabeledAddress) : [];
};

export const sanitizeLabeledAddress = (labeledAddress) => {
    return {
        label: labeledAddress.label,
        line1: labeledAddress.line1,
        line2: labeledAddress.line2,
        locality: labeledAddress.locality,
        region: labeledAddress.region,
        postalCode: labeledAddress.postalCode,
        country: labeledAddress.country,
    }
};

export const formatPhone = (raw) => {
    const phone = parsePhoneNumberWithError(raw, "US");

    return phone.formatNational();
};

export const addressToLines = (address) => {
    const lines = [];

    if (address.line1) {
        arrays.addTo(lines, address.line1);
    }

    if (address.line2) {
        arrays.addTo(lines, address.line2);
    }

    if (address.locality && address.region && address.postalCode) {
        arrays.addTo(lines, `${address.locality}, ${address.region} ${address.postalCode}`);

    } else if (address.locality && address.region) {
        arrays.addTo(lines, `${address.locality}, ${address.region}`);

    } else if (address.locality && address.postalCode) {
        arrays.addTo(lines, `${address.locality}, ${address.postalCode}`);

    } else if (address.region && address.postalCode) {
        arrays.addTo(lines, `${address.region} ${address.postalCode}`);

    } else if (address.locality) {
        arrays.addTo(lines, address.locality);

    } else if (address.region) {
        arrays.addTo(lines, address.region);

    } else if (address.postalCode) {
        arrays.addTo(lines, address.postalCode);
    }

    if (address.country) {
        arrays.addTo(lines, address.country);
    }

    return lines;
};

export const addressToItem = (address) => {
    return {
        label: address.label,
        line1: address.line1,
        line2: address.line2,
        locality: address.locality,
        region: address.region,
        postalCode: address.postalCode,
        country: address.country,
    }
};

export const openInGoogleMaps = (address) => {
    const lines = addressToLines(address);
    const query = strings.commaSeparated(lines);

    window.open("https://www.google.com/maps/search/?api=1&query=" + encodeURI(query), "google_maps");
};

export const openInBrowser = (item) => {
    window.open(item.value, item.label);
};

export const popSms = (item) => {
    communication.popSms(item.value);
};

export const popCall = (item) => {
    communication.popCall(item.value);
};

export const popEmail = (item) => {
    communication.popEmail(item.value);
};

export const popBulkEmail = (user, nodes, label) => {
    const emails = [];

    nodes.forEach(node => {
        node.emails.filter(email => email.label === label).forEach(email => {
            arrays.addTo(emails, email.value);
        });
    });

    let url = "mailTo:" + user.email;
    url += "?bcc=" + strings.commaSeparated(emails);

    window.location.href = url;
};

export const sortByLabel = (a, b) => sorting.sortByField(a, b, "label");

export const getLabels = (items) => {
    const array = getFields(items, "label");

    if (array.length > 0) {
        arrays.prependTo(array, LABEL_ANY);

    } else {
        arrays.prependTo(array, LABEL_NONE);
    }

    return array;
};

export const getValues = (items) => {
    return getFields(items, "value");
};

export const getFields = (items, field) => {
    return items
        .map(item => item[field])
        .filter(objects.notNullOrUndefined);
};

export const getName = (node) => {
    const name = users.getFullName(node);

    return name === misc.UNKNOWN ? ANONYMOUS : name;
};
